angular.module('swapick')
.directive('objectsList', objectsList)
.directive('objectsGrid', objectsGrid)
.directive('objectCard', objectCard)
.directive('userInfo', userInfo)
.directive('delegateClick', delegateClick)
.directive('customOnChange', customOnChange)
.directive('stellarScroll', stellarScroll);

function objectsList(){
    return {
        scope : { objects : "="},
        restrict: 'A',
        templateUrl : 'templates/objects_list.html',
        link: function (scope, iElement, iAttrs) {

        }
    };
}

function objectsGrid(){
    return {
        scope : { objects : "=", ctrl : "="},
        restrict: 'A',
        templateUrl : 'templates/objects_grid.html',
        link: function (scope, iElement, iAttrs) {

        }
    };
}

function objectCard(){
    return {
        scope : { obj : "=", ctrl : "="},
        restrict: 'A',
        replace : true,
        templateUrl : 'templates/object_card.html',
        link: function (scope, iElement, iAttrs) {

        }
    };
}


function userInfo(){
    return {
        scope : { user : "="},
        restrict: 'A',
        templateUrl : 'templates/user_info.html',
        link: function (scope, iElement, iAttrs) {

        }
    };
}


function stellarScroll ($timeout) {
    console.log("xxx")
    return {
        restrict: 'A',
        link: function ($scope, $element, $attr) {

            $timeout(function () {
                console.error("aaaa")
                $(".scroll").stellar({
                    scrollProperty: 'transform',
                    positionProperty: 'transform',
                    horizontalScrolling: false,
                    //verticalOffset: -150
                });

            })
        }

    }
}

function customOnChange() {
  return {
    restrict: 'A',
    scope : { customOnChange:"=" },
    link: function (scope, element, attrs) {


      element.bind("change", function (changeEvent) {
                var reader = new FileReader();
                reader.onload = function (loadEvent) {
                    scope.customOnChange(loadEvent.target.result)
                    element.value = "";
                }
                reader.readAsDataURL(changeEvent.target.files[0]);
            });
        }
    };
}

function delegateClick() {
  return {
    restrict: 'A',

    link: function (scope, element, attrs) {

            element.bind("click", function (changeEvent) {
                $(attrs.delegateClick).click();
                //var event = new Event('click');
                //document.querySelector(attrs.delegateClick).dispatchEvent(event);
            });
        }
    };
}



// WEBPACK FOOTER //
// ./src/directives/objects-list.js